const CACHE_INSTANT_SEARCH_RESULTS_KEY = 'ppcache_results';

export const getCachedInstantSearchResults = (collection) => {
  const cachedResults = sessionStorage.getItem(
    `${CACHE_INSTANT_SEARCH_RESULTS_KEY}__${collection}`
  );
  return cachedResults ? JSON.parse(cachedResults) : null;
};

export const setCachedInstantSearchResults = (collection, results) => {
  sessionStorage.setItem(
    `${CACHE_INSTANT_SEARCH_RESULTS_KEY}__${collection}`,
    JSON.stringify(results)
  );
};

export const clearCachedInstantSearchResults = (collection) => {
  sessionStorage.removeItem(`${CACHE_INSTANT_SEARCH_RESULTS_KEY}__${collection}`);
};
